import { render, staticRenderFns } from "./PosturaDetail.vue?vue&type=template&id=79e13404"
import script from "./PosturaDetail.vue?vue&type=script&lang=js"
export * from "./PosturaDetail.vue?vue&type=script&lang=js"
import style0 from "./PosturaDetail.vue?vue&type=style&index=0&id=79e13404&prod&lang=css"
import style1 from "./PosturaDetail.vue?vue&type=style&index=1&id=79e13404&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports